import React, { Component } from "react";
import "./index.scss";
import Quiz from "./components/quiz";
import Sticker from "./components/sticker";
import ExternalCampaignAuth from "./components/externalCampaignAuth";
import VideoPlayer from "./components/videoPlayer";
import VideoModal from "./components/videoModal";
import { withRouter } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Loader from "./components/loader";
import CustomLoader from "./components/loader";
import Results from "./components/results";
import EmptyCampaign from "./components/emptyCampaign";
import AxiosClient from "../../Network/AxiosClient";
import { decryptText } from "./utils/crypto";
import sample from "./dummy/dummy";

class ExternalCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSccreen: null,
      initialData: null,
      quizData: null,
      resultData: null,
      quizId: null,
      checkingAuthData: false,
      checkingQuizSubmission: false,
      wallet_number: null,
      authenticationErrorMessage: null,
      quiz_start_time: null,
      emptyCampaignData: null,
    };
  }

  callBackFromVideoScreen = () => {
    this.setState({ currentSccreen: "authentication" });
  };

  callBackFromAuthentication = (wallet_number) => {
    this.authenticate(this.state.quizId, wallet_number);
  };

  callBackFromQuiz = (submissionBody) => {
    this.postQuizSubmission(submissionBody);
  };

  fetchInitialData = (id) => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/survey/v1/quiz?id=${id}`
    )
      .then((res) => {
        this.setState({ initialData: res.data }, () =>
          this.setState({ currentSccreen: "videoPlayer" })
        );
      })
      .catch((err) => {
        console.log(err.response);
        this.setState({ emptyCampaignData: err?.response?.data }, () =>
          this.setState({ currentSccreen: "emptyCampaign" })
        );
        console.log(err);
      });
  };

  authenticate = (quizId, wallet_number) => {
    this.setState({
      checkingAuthData: true,
      wallet_number: wallet_number,
      authenticationErrorMessage: null,
    });
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/survey/v1/quiz-access?id=${quizId}&wallet_number=${wallet_number}`
    )
      .then((res) => {
        const isParticipated = res.data.participated;
        if (!isParticipated)
          this.setState(
            {
              quizData: {
                ...res.data,
                question_answer: res.data.aq
                  ? JSON.parse(decryptText(wallet_number, quizId, res.data.aq))
                  : res.data.question_answer,
              },
              checkingAuthData: false,
              quiz_start_time: new Date(),
            },
            () => this.setState({ currentSccreen: "quiz" })
          );
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.data?.participated === true) {
          this.setState(
            { resultData: err.response.data, checkingAuthData: false },
            () => this.setState({ currentSccreen: "results" })
          );
        }
        this.setState({
          checkingAuthData: false,
          authenticationErrorMessage: err?.response?.data?.message,
        });
      });
  };

  postQuizSubmission = (submissionBody) => {
    const cleanedSubmissionBody = submissionBody.map(
      ({ isCorrect, ...rest }) => rest
    );
    this.setState({ checkingQuizSubmission: true });
    AxiosClient.post(
      `${process.env.REACT_APP_API_URL}/api/survey/v1/quiz-answers`,
      {
        quiz_id: this.state.quizId,
        wallet_number: this.state.wallet_number,
        question_answer: cleanedSubmissionBody,
        quiz_start_time: this.state.quiz_start_time,
        quiz_end_time: new Date(),
      }
    )
      .then((res) => {
        this.setState(
          { resultData: res.data, checkingQuizSubmission: false },
          () => this.setState({ currentSccreen: "results" })
        );
      })
      .catch((err) => {
        this.setState({ checkingQuizSubmission: false });
        console.log(err);
      });
  };

  componentDidMount() {
    // Read URL parameters
    // const p = decryptText("1312341252", "EID-2K25", sample);
    // console.log(JSON.parse(p));
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");
    this.setState({ currentSccreen: "loader", quizId: id });
    this.fetchInitialData(id);
  }

  render() {
    const {
      currentSccreen,
      initialData,
      checkingAuthData,
      checkingQuizSubmission,
      quizData,
      emptyCampaignData,
    } = this.state;
    return (
      <div className="external-campaign-outer-container">
        <div
          className="external-campaign-inner-container"
          style={{ padding: currentSccreen === "videoPlayer" ? 0 : 20 }}
        >
          {currentSccreen === "emptyCampaign" && (
            <EmptyCampaign data={emptyCampaignData} />
          )}
          {currentSccreen === "loader" && (
            <CustomLoader color="#E2136E" size={40} />
          )}

          {currentSccreen === "videoPlayer" && (
            <VideoPlayer
              data={initialData}
              isShort={true}
              callBack={this.callBackFromVideoScreen}
            />
          )}
          {currentSccreen === "authentication" && (
            <ExternalCampaignAuth
              data={{
                guide: initialData.whitelisting_screen_text_instruction,
                max_payout_amount: initialData.max_payout_amount,
              }}
              callBack={this.callBackFromAuthentication}
              fetching={checkingAuthData}
              errorMessage={this.state.authenticationErrorMessage}
            />
          )}
          {currentSccreen === "quiz" && (
            <Quiz
              data={{ ...quizData, video_link: initialData.video_link }}
              callBack={this.callBackFromQuiz}
              checking={checkingQuizSubmission}
            />
          )}
          {currentSccreen === "results" && (
            <Results data={this.state.resultData} />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(ExternalCampaign);
